import React from "react";
import { Helmet } from "react-helmet";
import get from "lodash/get";

export default (props) => {
  const title = get(props, "title", "uizard");
  const description = get(props, "description", "The easy-to-use design tool");
  const url = get(props, "url", "");
  const noindex = get(props, "noindex", false);
  const faqschema = get(props, "faqschema", false);
  const canonical = get(props, "canonical", false);
  const metaimage = get(props, "metaimage", "https://uizard.io/opengraph-2021-04-26-10-35.png");

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />

      <meta property="og:url" content={`https://uizard.io${url}`} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content={metaimage}
      />

      <link
        rel="canonical"
        href={
          canonical === false
            ? `https://uizard.io${url}`
            : `https://uizard.io${canonical}`
        }
      />

      {noindex === true ? <meta name="robots" content="noindex" /> : ""}
      {faqschema !== false ? (
        <script type="application/ld+json">{faqschema}</script>
      ) : (
        ""
      )}
    </Helmet>
  );
};
